import React from 'react'
import getURLParams from '../../../helpers/getURLParams'
import customRequest from '../../../helpers/customRequest'
import message from '../../../components/message/message'
import redirect from '../../../components/redirect/redirect'
import ClipLoader from 'react-spinners/ClipLoader'
import { initializeFormValidation } from '../../../helpers/forms/form-validation'

class Delete extends React.Component
{
    state = {
        student: "",
        submitting: false
    }
    componentDidMount()
    {
        var params = getURLParams()
        this.setState({student: params.student})
        initializeFormValidation(this.onSubmit)
    }

    onSubmit = (event) => {
        this.setState({submitting: true}, () => {
            customRequest.post('/api/students/remove', {
                studentName: this.state.student
            })
            .then(({data}) => {
                message.clear()
                redirect.send("/students", () => {
                    if (data.valid) {
                        message.success("Your student has been successfully removed.")
                    }
                    else {
                        message.error(data.message)
                    }
                })
            })
        })
    }

    render()
    {
        return (
            <React.Fragment>
                <h1>Delete Student</h1>
                <form class = "form-horizontal prevent-next-submit form-validate" noValidate method = "post">
                    <div class = "form-group row">
                        <label class = "d-none d-sm-inline col-sm-6 control-label text-right">Name</label>
                        
                        <div class = "col-sm-6">
                            <p class = "form-control-static text-left text-center-xs break-words">{this.state.student}</p>
                        </div>
                    </div>
                    
                    <button type = "submit" class = "btn btn-secondary btn-lg" disabled={this.state.submitting}>{this.state.submitting ?
                    <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Delete"}</button>
                </form>
            </React.Fragment>
        )
    }
}

export default Delete
